import { apiRequestWithChecks } from "./api";

export const user = {
  getUserInfo: function (token) {
    return apiRequestWithChecks("GET", "/api/user", {
      Authorization: "Bearer " + token,
      "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  },

  getUserCount: function (token) {
    return apiRequestWithChecks("GET", "/api/user/count", {
      Authorization: "Bearer " + token,
    });
  },

  getUserTypes: function (token) {
    return apiRequestWithChecks("GET", "/api/user/types", {
      Authorization: "Bearer " + token,
    });
  },

  getUserProfile: function (token) {
    return apiRequestWithChecks("GET", "api/user/GetUserProfile", {
      Authorization: "Bearer " + token,
      "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  },
  getUserProfileForSpecificUser: function (token, userId) {
    return apiRequestWithChecks(
      "GET",
      "/api/user/GetUserProfileForSpecificUser?userId=" + userId,
      {
        Authorization: "Bearer " + token,
      }
    );
  },
  getUserOrganizationDetails: function (token) {
    return apiRequestWithChecks("GET", "/api/user/GetUserOrganizationDetails", {
      Authorization: "Bearer " + token,
    });
  },
  getRecentMessages: function (token, messageType, getOnlyUnreadMessages) {
    return apiRequestWithChecks(
      "GET",
      "api/dashboard/GetRecentMessages?alertType=" +
      messageType +
      "&getOnlyUnreadMessages=" +
      getOnlyUnreadMessages,
      {
        Authorization: "Bearer " + token,
      }
    );
  },
  getRecentMessagesForSpecificUser: function (token, messageType, getOnlyUnreadMessages, userId) {
    return apiRequestWithChecks(
      "GET",
      `/api/dashboard/getRecentMessagesForSpecificUser?alertType=${messageType}&getOnlyUnreadMessages=${getOnlyUnreadMessages}&userId=${userId}`,
      {
        Authorization: "Bearer " + token,
      }
    );
  },
  getMessagePreview: function (token, alertId) {
    return apiRequestWithChecks(
      "GET",
      "api/dashboard/getPreviewAlertDetail?alertId=" + alertId,
      {
        Authorization: "Bearer " + token,
      }
    );
  },
  getSpecificUserDetails: function (token) {
    return apiRequestWithChecks(
      "GET",
      "api/user/GetSpecificUserProfileDetail",
      {
        Authorization: "Bearer " + token,
      }
    );
  },
  getSpecificDetailForSpecificUser: function (token, userId) {
    return apiRequestWithChecks(
      "GET",
      "/api/user/GetSpecificDetailForSpecificUser?userId=" + userId,
      {
        Authorization: "Bearer " + token,
      }
    );
  },
  updateUserProfile: function (token, payload) {
    return apiRequestWithChecks(
      "PUT",
      "/api/user/update",
      {
        Authorization: "Bearer " + token,
      },
      payload
    );
  },
  updateUserProfileForSpecificUser: function (token, payload, userId) {
    return apiRequestWithChecks(
      "PUT",
      "/api/user/UpdateUserProfileForSpecificUser?userId=" + userId,
      {
        Authorization: "Bearer " + token,
      },
      payload
    );
  },
  updatePreference: function (token, payload) {
    return apiRequestWithChecks(
      "PUT",
      "/api/dashboard/updatePreference",
      {
        Authorization: "Bearer " + token,
      },
      payload
    );
  },
  updatePreferenceForSpecificUser: function (token, payload, userId) {
    return apiRequestWithChecks(
      "PUT",
      "/api/dashboard/UpdatePreferenceForSpecificUser?userId=" + userId,
      {
        Authorization: "Bearer " + token,
      },
      payload
    );
  },
  updateReadMessageProperty: function (token, payload) {
    return apiRequestWithChecks(
      "PUT",
      "/api/dashboard/updateReadMessageProperty",
      {
        Authorization: "Bearer " + token,
      },
      payload
    );
  },

  getAlertCredit: function (token, payload) {
    return apiRequestWithChecks(
      "GET",
      "/api/alertCredit",
      { Authorization: "Bearer " + token },
      payload
    );
  },
  getEmailCredit: function (token, payload) {
    return apiRequestWithChecks(
      "GET",
      "/api/alertCredit/emailQuota",
      { Authorization: "Bearer " + token },
      payload
    );
  },

  amplifyLogin: function (payload) {
    return apiRequestWithChecks(
      "POST",
      "/api/authentication/amplify_login",
      null,
      payload
    );
  },

  uploadProfilePhoto: function (token, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiRequestWithChecks(
      "POST",
      "/api/user/UploadProfilePhoto",
      {
        Authorization: "Bearer " + token,
      },
      formData
    );
  },
  uploadProfilePhotoForSpecificUser: function (token, file, userId) {
    const formData = new FormData();
    formData.append("file", file);
    return apiRequestWithChecks(
      "POST",
      "/api/user/UploadProfilePhotoForSpecificUser?userId=" + userId,
      {
        Authorization: "Bearer " + token,
      },
      formData
    );
  },
  ValidateUnitySession: function (sessionKey) {
    return apiRequestWithChecks(
      "POST",
      "/api/authentication/ValidateUnitySession?sessionKey=" + sessionKey
    );
  },
  getUserTypeDropdown: function (token) {
    return apiRequestWithChecks(
      "GET",
      `/api/user/user-type-dropdown`,
      {
        Authorization: "Bearer " + token,
      }
    );
  },
  getUserProduct: function (token) {
    return apiRequestWithChecks(
      "GET",
      `/api/user/user-product`,
      {
        Authorization: "Bearer " + token,
      }
    );
  }
};
